var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2989 3.0011L5.79723 3.00617C4.41762 3.00773 3.30005 4.12656 3.30005 5.50617V9.99997C3.30005 10.5523 3.74776 11 4.30005 11H10.3C10.8523 11 11.3 10.5523 11.3 9.99997V4.0011C11.3 3.44881 10.8523 3.0011 10.2989 3.0011ZM4.29892 13.0079C3.74708 13.0085 3.30005 13.456 3.30005 14.0079V18.5C3.30005 19.8807 4.41934 21 5.80005 21H10.3C10.8523 21 11.3 20.5523 11.3 20V14.0011C11.3 13.4488 10.8523 13.0011 10.2989 13.0011L4.29892 13.0079ZM13.3 4.01773C13.3 3.46644 13.7462 3.01913 14.2975 3.01774L18.7937 3.00633L18.8 3.00632C20.1808 3.00632 21.3 4.12561 21.3 5.50632V18.5C21.3 19.8807 20.1808 21 18.8 21H14.3C13.7478 21 13.3 20.5523 13.3 20V4.01773ZM5.80005 19C5.52391 19 5.30005 18.7761 5.30005 18.5V15.0067L9.30005 15.0022V19H5.80005ZM9.30005 8.99997H5.30005V5.50617C5.30005 5.23025 5.52356 5.00648 5.79948 5.00617L9.30005 5.00223V8.99997ZM18.8 19C19.0762 19 19.3 18.7761 19.3 18.5V5.50632C19.3 5.23018 19.0762 5.00632 18.8 5.00632L15.3 5.0152V19H18.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscovery);
export default __webpack_public_path__ + "static/media/discovery.2815d40b85edf9770db7b97a90583676.svg";
export { ForwardRef as ReactComponent };